import adMarker from "../../../../assets/svg/scheduling/adMarkerLoop.svg";
import promoMarker from "../../../../assets/svg/scheduling/adMarkerLoopPromo.svg";

export const AdBreaksContainer = ({
    calculateMinutes,
    data,
    zoomInOut,
    linePosition,
    hoveredId,
    draggableType,
    hoverTime
}) => {
    return (
        <div
          style={{
            height: `${calculateMinutes(
              data?.durationInMillis +
                data?.adBreaks?.reduce((sum, ad) => sum + ad?.durationInMillis, 0) || 0
            ) * zoomInOut}px`,
            width: "36px",
            position: "relative",
          }}
        >
          {linePosition !== null &&
            hoveredId === data?.sequence &&
            (draggableType === "fillers" || draggableType === "ads" || draggableType === "promos") && (
              <div
                style={{
                  position: "absolute",
                  pointerEvents: "none",
                  top: `${linePosition}px`,
                  zIndex: "9999",
                  left: "-8",
                //   width: "460px",
                  width: "21.25rem",
                  height: "2px",
                  backgroundColor: "blue",
                }}
              >
                <span
                  style={{
                    position: "absolute",
                    zIndex: "99999999",
                    top: "-22px",
                    left: "0px",
                    // backgroundColor: "white",
                    padding: "2px 5px",
                    fontSize: "12px",
                  }}
                >
                  {hoverTime} min
                </span>
              </div>
            )}
    
          {data?.adBreaks?.length !== 0 &&
            data?.adBreaks?.map((ad) => {
              const style = {
                    position: "absolute",
                    top: `${calculateMinutes(ad?.startOffsetInMillis) * zoomInOut}px`,
                    height: "0px",
                  }
              return (
                <span key={ad?.adSqId} style={{ position: "absolute", zIndex: `${ad?.adSqId}`, ...style }}>
                  <img
                    src={ad?.assetType === "PROMO"? promoMarker : adMarker}
                    width={35}
                    style={{ position: "absolute", top: "-4px" }}
                    alt="ad marker"
                  />
                </span>
              );
            })}
        </div>
    );
}